import React, { useState } from "react";
import { FaEye } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";

const CommonModal = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <FaEye
        className="text-black action-btn"
        onClick={() => setShowModal(true)}
      />
      {showModal && (
        <div className="custom-modal">
          <div>
            <div className="close">
              <IoClose
                className="close-btn"
                onClick={() => setShowModal(false)}
              />
            </div>
            {children}
          </div>
        </div>
      )}
    </>
  );
};

export default CommonModal;
